// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.9158 0.585449L10.4657 2.25967C10.1658 3.37554 10.1958 4.59695 10.5353 5.86378C11.5359 9.59804 15.3742 11.8141 19.1085 10.8135C19.5546 10.694 19.9781 10.5344 20.3766 10.3398L21.917 9.58766L21.8135 11.2988C21.7509 12.3323 21.4388 13.3586 20.8944 14.4473L20.618 15.0001H2.82804L2.52422 14.2542C2.49437 14.1797 2.45369 14.0772 2.41064 13.9662C2.33368 13.7676 2.22031 13.4689 2.17013 13.2816C0.74071 7.94694 3.90653 2.46357 9.2412 1.03415L10.9158 0.585449ZM2.00098 17.0001H8.00098V19.0001H2.00098V17.0001ZM10.001 17.0001H22.001V19.0001H10.001V17.0001ZM17.001 21.0001H22.001V23.0001H17.001V21.0001ZM2.00098 21.0001H15.001V23.0001H2.00098V21.0001Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-fog-night-filled')
export default class FogNightFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'fog-night-filled',
    }
  }
}
